import axios from "axios";
import { useEffect, useState } from "react";
import { Live_URL } from "../../../config";

const table = ["Name", "Email", 'Phone', "Message"]

function SupportList() {
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [supports, setSupports] = useState([])

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await axios.get(`${Live_URL}/api/supports`, {
                    params: {
                        page,
                        limit,
                    },
                });
                setSupports(res.data?.data?.reverse());
                setTotalPages(res.data?.totalPages);
                setTotalItems(res.data?.totalItems);
            } catch (error) {
                console.error("Failed to fetch blogs:", error);
            }
        };

        fetchBlogs();
    }, [page, limit]);

    useEffect(() => {
        document.title = "Dashboard | Supports";
    }, [])


    return (
        <div className="mx-4">
            <div className="overflow-x-auto shadow mt-4 rounded-md bg-white">
                <table className="table table-sm">
                    <thead>
                        <tr>
                            {table.map(item => (
                                <th key={item} className="font-semibold text-lg">{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <>
                            {supports?.length > 0 ? (
                                supports.map((blog) => (
                                    <tr key={blog._id} className="text-lg">
                                        <td>{blog?.name}</td>
                                        <td>{blog?.email}</td>
                                        <td>{blog?.phone}</td>
                                        <td>{blog?.message}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="m-4 text-xl text-center">No Reacord Found</td>
                                </tr>
                            )}
                        </>
                    </tbody>
                </table>
            </div>
            {supports?.length > 0 && (
                <div className="flex justify-between items-center mt-4">
                    <button
                        className="btn btn-primary"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Previous
                    </button>
                    <span>
                        Page {page} of {totalPages} - Total Items: {totalItems}
                    </span>
                    <button
                        className="btn btn-primary"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    )
}

export default SupportList;